import ApiCalling from "../../ApiServices/ApiCalling";
import { useState } from "react";

const BillPaymentService = () => {
  const [getOpTypeData, setOpTypeData] = useState([]);
  
  const paymentServiceOption = async (e) => {
    try {
      const res = await ApiCalling.request("POST", "/GetOpTypes", null, null);
      if (res?.statuscode === 1) {
        setOpTypeData(res?.data?.assignedOpTypes || []);
      } else {
        console.error(res?.msg, { toastId: "paymentServiceOption error" });
      }
    } catch (error) {
      console.error("Error paymentServiceOption :", error);
    }
  };

  return { paymentServiceOption, getOpTypeData };
};

export default BillPaymentService;
